export default __webpack_public_path__ + "static/media/thermometer 1.4051ae7a.svg";